import { COUNTRIES, CALLING_CODES } from "shared/constants";
import { Flag } from "shared/components";

export interface ICountry {
  code: string;
  name: string;
  callingCode?: string;
  flag?: JSX.Element;
}

//  Get the country name and flag from the country code
export const getCountry = (code: string): ICountry | undefined => {
  const name = COUNTRIES[code];
  const flag = <Flag countryCode={code} />;

  if (name) {
    return { code, name, flag };
  }
};

export const getSortedCountries = (): ICountry[] => {
  const countries = Object.keys(COUNTRIES).map(code => ({
    code,
    name: COUNTRIES[code],
    callingCode: CALLING_CODES[code],
    flag: <Flag countryCode={code} />,
  }));

  // sorting strings https://stackoverflow.com/a/40355107
  return countries.sort((a, b) => +(a.name > b.name) || -(a.name < b.name));
};
